import React from 'react';
import { useIntl } from 'react-intl';
import { defineMessages } from 'react-intl.macro';

import ChipSuccess, { ChipSuccessProps } from './ChipSuccess';

const messages = defineMessages({
  label: {
    id: 'components.v2.ChipNew.label',
    defaultMessage: 'New',
  },
});

export interface ChipNewProps extends Omit<ChipSuccessProps, 'classes' | 'label'> {}

const ChipNew: React.FC<ChipNewProps> = ({ ...rest }) => {
  const { formatMessage } = useIntl();

  return <ChipSuccess label={formatMessage(messages.label)} {...rest} />;
};

export default ChipNew;
